import { NgClass } from '@angular/common'
import { CommonModule } from '@angular/common'
import {
    Component,
    inject,
    OnInit,
    signal,
    ChangeDetectionStrategy,
} from '@angular/core'
import { ShopsApiService } from '@baboor/baboor-api'
import { AuthStateService } from '@baboor/baboor-auth'
import { HeaderDefaultComponent } from '../../../headers/components/header-default/header-default.component'
import { SidebarVendorComponent } from '../../../sidebars/components/sidebar-vendor/sidebar-vendor.component'
@Component({
    selector: 'app-layout-vendor-default',
    imports: [
        HeaderDefaultComponent,
        SidebarVendorComponent,
        NgClass,
        CommonModule,
    ],
    templateUrl: './layout-vendor-default.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './layout-vendor-default.component.css',
})
export class LayoutVendorDefaultComponent implements OnInit {
    private authStateService = inject(AuthStateService)
    private shopsApi = inject(ShopsApiService)
    isSidebarCollapsed = false
    isMobileSidebarOpen = false
    isClient = signal(false)
    groupType = signal<string | null>(null)

    ngOnInit() {
        this.groupType.set(this.authStateService.getGroupType() ?? null)
        this.isClient.set(this.groupType() === 'client')
        this.shopsApi.getSettings().subscribe({
            error: () => {
                // Non-blocking fallback
            },
        })
    }

    toggleSidebar() {
        if (window.innerWidth <= 768) {
            this.isMobileSidebarOpen = !this.isMobileSidebarOpen
        } else {
            this.isSidebarCollapsed = !this.isSidebarCollapsed
        }
    }

    closeMobileSidebar() {
        this.isMobileSidebarOpen = false
    }
}
